export default {
  path: '/record',
  name: 'Record',
  redirect: '/record/list',
  component: () => import('@/components/layout'),
  meta: {requiresAuth: true},
  children: [
    {
      path: 'list',
      component: () => import('@/views/record'),
      meta: {requiresAuth: true},
    },
    {
      path: 'youthSs',
      name: 'youthSs',
      component: () => import('@/views/record/youthSs'),
      meta: {requiresAuth: true},
    },
    {
      path: 'recordDetail',
      name: 'RecordDetail',
      component: () => import('@/views/record/recordDetail'),
      meta: {requiresAuth: true},
    },
    {
      path: 'youthList',  // 机构管理员提交记录列表
      name: 'YouthList',
      component: () => import('@/views/record/youthList'),
      meta: {requiresAuth: true}
    },
    {
      path: 'addRecordYouthToSquad',  // 机构管理员提交球队
      name: 'AddRecordYouthToSquad',
      component: () => import('@/views/record/components/addRecordYouthToSquad'),
      meta: {requiresAuth: true}
    },
    {
      path: 'addRecordYouthToSquadAudit',  // 机构管理员提交审核球队
      name: 'AddRecordYouthToSquadAudit',
      component: () => import('@/views/record/components/addRecordYouthToSquadAudit'),
      meta: {requiresAuth: true}
    },
    {
      path: 'youthPlayerList',  // 机构管理员提交球员记录列表
      name: 'YouthPlayerList',
      component: () => import('@/views/record/youthPlayerList'),
      meta: {requiresAuth: true}
    },
    {
      path: 'addRecordYouthToPlayer',  // 机构管理员提交球员
      name: 'AddRecordYouthToPlayer',
      component: () => import('@/views/record/components/addRecordYouthToPlayer'),
      meta: {requiresAuth: true}
    },
    {
      path: 'addRecordYouthToPlayerAudit',  // 机构管理员提交审核球员
      name: 'AddRecordYouthToPlayerAudit',
      component: () => import('@/views/record/components/addRecordYouthToPlayerAudit'),
      meta: {requiresAuth: true}
    },
    {
      path: 'auditYouthPlayerList',  // 机构管理员审核集训机构
      name: 'AuditYouthPlayerList',
      component: () => import('@/views/record/auditYouthPlayerList'),
      meta: {requiresAuth: true}
    },
  ]
}
